interface OptimizedImageProps {
  src: string;
  alt: string;
  className?: string;
  width?: number;
  height?: number;
  priority?: boolean;
}

/**
 * Optimized image component that serves WebP images
 * Automatically converts .jpeg/.jpg paths to .webp
 */
export function OptimizedImage({
  src,
  alt,
  className,
  width,
  height,
  priority = false,
}: OptimizedImageProps) {
  // Convert JPEG/JPG paths to WebP
  const optimizedSrc = src.replace(/\.jpe?g$/i, '.webp');

  return (
    <img
      src={optimizedSrc}
      alt={alt}
      className={className}
      width={width}
      height={height}
      loading={priority ? 'eager' : 'lazy'}
      decoding={priority ? 'sync' : 'async'}
    />
  );
}
